var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[_c('v-main',[_c('router-view',{staticClass:"pa-2",on:{"authenticated":_vm.setAuthenticated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }